
import { Component,Prop, Watch,BaseMixins } from '@/lib';
import Velocity from 'velocity-animate'
@Component({name:"query-bar"})
export default class QueryBar extends BaseMixins {
  /*查询dispatch type     module/menu/action*/
  @Prop({ type: String, required: true }) queryAction: string; 
  /*查询model*/
  @Prop({type:Object}) model:any;
  /*store table name 默认根据query解析*/
  @Prop({type:String, default:"table"}) resultFieldName:string;
  /*页面加载自动查询*/
  @Prop({type:Boolean, default: true}) isAutoQuery:boolean;
  /*query bar组件的refs名称*/
  @Prop({type:String, default: 'querybar'}) $refsName:string;

  @Prop({type:Boolean, default: false}) advancedQuery:boolean;

  @Prop({type:Number, default: 150}) labelWidth:number;

  searchButtonConfig:any={align:"right", offset:0};

  arrowDown: boolean = false;

  showSearchButton: boolean = true;

  async created(){
    if(this.isAutoQuery){
      this.query();
    }
  }

  get model_(){
    return this.model || {};
  }

  get tableData(){
    let arr = this.queryAction.split("/");
    return this.$store.state[arr[0]][arr[1]][this.resultFieldName];
  }

  get commitType(){
    let arr = this.queryAction.split("/");
    return arr[0]+"/"+arr[1]+"/";
  }

  /*页码更改时 触发查询*/
  @Watch("tableData.currentPage")
  pageChange(value){
    this.query();
  }

  /*每页数量更改时 触发查询*/
  @Watch("tableData.pageSize")
  pageSizeChange(value){
    this.query();
  }

  /*查询*/
  query(){
    let pageData = { maxResultCount:this.tableData.pageSize, skipCount: (this.tableData.currentPage - 1) * this.tableData.pageSize };
    this.$store.dispatch({type: this.queryAction, data: Object.assign({}, this.model_, pageData)});
  }

  /*刷新*/
  refresh(){
    this.query();
  }

  search(){
    if(this.tableData.currentPage === 1){
      this.query();
    } else {
      let map = new Map();
      map.set("table", this.resultFieldName);
      map.set("currentPage", 1);
      this.$store.commit(this.commitType + "setPageData", map);
    }
  }

  /*查询条件重置*/
  async reset(){
    (this.$refs[this.$refsName] as any).resetFields();
    await this.$emit("reset");
    this.search();
  }

  async mounted(){
    this.getSearchButtonConfig();
  }

  /*根据查询条件数量 设置searchbutton的位置*/
  getSearchButtonConfig(){
    let children = this.$slots["default"];
    if(children){
      this.setSearchButtonPosition(children.length);
    }
  }

  get advancedSlots(){
      return this.$slots["advanced-field"] != undefined;
  }

  expendAdvanceQuery(){
    this.arrowDown = !this.arrowDown;
    let defaultSlots = this.$slots["default"];
    let advanceSlots = this.$slots["advanced-field"];
    let length = this.arrowDown? defaultSlots.length + advanceSlots.length: defaultSlots.length ;
    this.setSearchButtonPosition(length);
    this.expandSearchForm(this.arrowDown, this.getRowCount(defaultSlots.length + advanceSlots.length), this.getRowCount(defaultSlots.length), () => { this.showSearchButton = !this.showSearchButton;})
  }

  getRowCount(length){
    if(length < 3) return 1;
    if(length % 3 == 0) return length/3 + 1;
    return Math.ceil(length/3)
  }

  setSearchButtonPosition(length:number){
    if(length < 3){
      this.searchButtonConfig = { align:"left", offset: 0 }
    }
    if(length >= 3 && length%3 == 0){
      this.searchButtonConfig = { align:"right", offset: 16 }
    }
    if(length >= 3 && length%3 == 1){
      this.searchButtonConfig = { align:"right", offset: 8 }
    }
    if(length >= 3 && length%3 == 2){
      this.searchButtonConfig = { align:"right", offset: 0 }
    }
  }

  expandSearchForm(isExpand: boolean, expandRowCount: number, reduceRowCount: number, callback: any = null) {
      if (callback) callback();
      let el = (this.$refs[this.$refsName] as any).$el;
      if (isExpand) {
          Velocity(el, { height: 56.89 * expandRowCount }, { duration: 200, complete: callback })
      } else {
          Velocity(el, { height: 56.89 * reduceRowCount }, { duration: 200, complete: callback })
      }
  };
}
